module.exports = __webpack_public_path__ + "img/china.4d4bf040.png";